import * as Yup from 'yup'

const cmsLuxurySectionEditScheme = Yup.object().shape({
  name     : Yup.string().required('name required'),
  order    : Yup.number().required('order required'),
  alt_text : Yup.string().required('alt text required')
})

export default cmsLuxurySectionEditScheme
